import PageContainer from '@/common/components/PageContainer'
import Spinner from '@/common/components/Spinner'
import useQueryGetAnnouncement from '@/modules/announcement/api/hooks/useQueryGetAnnouncement'
import AnnouncementListing from '@/modules/announcement/components/Announcement/components/AnnouncementListing'
import { useState } from 'react'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { PermissionKeys } from '@/modules/manage-member/mappers'

const PAGE_SIZE = 10

// Separate component for the actual announcement functionality
function AnnouncementContent() {
	const [page, setPage] = useState(1)

	const payload = {
		take: PAGE_SIZE,
		skip: (page - 1) * PAGE_SIZE,
	}

	const { data = { total: 0, take: 0, skip: 0, data: [] }, isLoading } =
		useQueryGetAnnouncement(payload)

	const fetchNextPage = () => {
		setPage((prev) => prev + 1)
	}

	const hasMore = data.data.length < data.total

	if (isLoading && !data) {
		return <Spinner />
	}

	return (
		<AnnouncementListing
			data={data}
			fetchNextPage={fetchNextPage}
			hasMore={hasMore}
		/>
	)
}

// Main component that checks permissions
export default function AnnouncementPage() {
	const { data: user } = useQueryProfile()
	const hasAnnouncementPermission =
		user?.userGroup.readPermission.includes(
			PermissionKeys.MANAGE_ANNOUNCEMENT,
		) ||
		user?.userGroup.writePermission.includes(PermissionKeys.MANAGE_ANNOUNCEMENT)

	return (
		<PageContainer>
			{hasAnnouncementPermission ? <AnnouncementContent /> : 'AUTO ADMIN'}
		</PageContainer>
	)
}
